import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { CategoryForm } from '../forms'
import { Dashboard } from '../layouts'
import axios from '../plugins/axios'

const styles = theme => ({
    //
})

class CategoryUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Төрөл',
            key: shortid.generate(),
            name: '',
            image: '',
        }
    }

    componentWillMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/categories/${id}`)

            this.setState({
                key: shortid.generate(),
                name: data.name,
                image: data.image,
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            title,
            key,
            name,
            image,
        } = this.state
        const { match } = this.props
        const { id } = match.params
        return (
            <Dashboard title={title}>
                <CategoryForm
                    key={key}
                    path={`categories/${id}`}
                    method="put"
                    name={name}
                    image={image}
                    message="Амжилттай шинэчлэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(CategoryUpdate)
